import { IconProps } from "../types";

export const MenuIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.17004 5.64482C1.65252 5.64482 1.25 5.20978 1.25 4.69741C1.25 4.18503 1.6621 3.75 2.17004 3.75H17.8491C18.3475 3.75 18.75 4.17537 18.75 4.69741C18.75 5.21945 18.3475 5.64482 17.8491 5.64482H2.17004ZM17.83 9.04776C18.3475 9.04776 18.7404 9.47312 18.7404 9.99517C18.7404 10.5172 18.3379 10.9426 17.83 10.9426H2.15088C1.65252 10.9426 1.25 10.4979 1.25 9.99517C1.25 9.49246 1.6621 9.04776 2.15088 9.04776H17.83ZM2.17004 16.25C1.65252 16.25 1.25 15.8053 1.25 15.3026C1.25 14.7999 1.6621 14.3552 2.17004 14.3552H17.8491C18.3475 14.3552 18.75 14.7805 18.75 15.3026C18.75 15.8246 18.3475 16.25 17.8491 16.25H2.17004Z"
        fill={fillColor ?? "#333333"}
      />
    </svg>
  );
};
